import LocalizedStrings from "react-localization";
import English from "./english";

const TextStrings = {
  in: English,
};

export default new LocalizedStrings(TextStrings);
